import { render, staticRenderFns } from "./myOperationComment.vue?vue&type=template&id=2c23344a&scoped=true"
import script from "./myOperationComment.vue?vue&type=script&lang=js"
export * from "./myOperationComment.vue?vue&type=script&lang=js"
import style0 from "./myOperationComment.vue?vue&type=style&index=0&id=2c23344a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c23344a",
  null
  
)

export default component.exports